module.exports = __webpack_public_path__ + "static/media/logo-neuvana-dark-x3.e87f94b7.png";